module.exports = __webpack_public_path__ + "img/truth-gpt-Elon-Musk-Tweet.eb3fa254.webp";